import React, { useState, useEffect } from 'react';
import { Snackbar, Button, IconButton, ThemeProvider, StyledEngineProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import useAlertContext from 'src/hooks/useAlertContext';

const theme = createTheme();

export default function SnakbarAlert() {
  const { alert, hideDuration, setAlert } = useAlertContext();
  const [snack, setSnack] = useState({
    message: '',
    action: null
  });

  const handleClose = (reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlert(null);
  };

  const handleAction = async () => {
    const { onClick, message } = snack.action;
    if (onClick) {
      if (message) {
        setAlert({
          message: 'Working...',
          action: null
        });
      }
      await onClick();
      if (message) {
        setAlert({
          message,
          action: null
        });
      }
    } else {
      console.error('Missing onClick at option of snackbar action.');
    }
  };

  useEffect(() => {
    if (alert) {
      setSnack(alert);
    }
  }, [alert]);

  return (
    <Snackbar
      open={!!alert}
      autoHideDuration={hideDuration}
      ClickAwayListenerProps={{
        mouseEvent: false
      }}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      message={snack.message}
      action={
        <>
          {snack.action && (
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={theme}>
                <Button color="secondary" size="small" onClick={handleAction}>
                  {snack.action.label}
                </Button>
              </ThemeProvider>
            </StyledEngineProvider>
          )}
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
    />
  );
}
